import React from 'react';

export const CloseIconRound = () => (
  <svg
    data-testid='close-icon-round'
    fill='none'
    height='28'
    viewBox='0 0 28 28'
    width='28'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect fill='#72767E' height='28' rx='14' width='28' />
    <circle cx='14' cy='14' fill='#72767E' r='12' />
    <path
      clipRule='evenodd'
      d='M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14ZM26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14ZM19.59 7L21 8.41L15.41 14L21 19.59L19.59 21L14 15.41L8.41 21L7 19.59L12.59 14L7 8.41L8.41 7L14 12.59L19.59 7Z'
      fill='white'
      fillRule='evenodd'
    />
  </svg>
);
